var l = Object.defineProperty;
var h = (t, s, e) => s in t ? l(t, s, { enumerable: !0, configurable: !0, writable: !0, value: e }) : t[s] = e;
var u = (t, s, e) => (h(t, typeof s != "symbol" ? s + "" : s, e), e);
function a({ dataset: t }) {
  return !["src", "srcset"].some((s) => s in t);
}
function v(t) {
  return (s, e) => {
    var r;
    for (const i of s) {
      if (!i.isIntersecting)
        continue;
      const o = i.target;
      e.unobserve(o), !a(o) && (c(o, t), (r = t == null ? void 0 : t.onLoaded) == null || r.call(t, o));
    }
  };
}
function c(t, { useNativeLoading: s = !1 }) {
  var n, f;
  const { src: e, srcset: r, sizes: i, poster: o } = t.dataset;
  if (e && (t.src = e, delete t.dataset.src), t instanceof HTMLVideoElement) {
    o && (t.poster = o, delete t.dataset.poster);
    return;
  }
  if (t instanceof HTMLImageElement && s && t.loading !== "lazy" && (t.loading = "lazy"), r && (t.srcset = r, delete t.dataset.srcset), i) {
    const d = t instanceof HTMLSourceElement ? (f = (n = t.parentElement) == null ? void 0 : n.getElementsByTagName("img")[0]) == null ? void 0 : f.offsetWidth : t.offsetWidth;
    t.sizes = i === "auto" ? d ? `${d}px` : "100vw" : i;
  }
}
const b = !("onscroll" in window) || /(gle|ing|ro)bot|crawl|spider/i.test(navigator.userAgent);
function L(t, s = document) {
  return typeof t == "string" ? [...s.querySelectorAll(t)] : t instanceof Element ? [t] : [...t];
}
class w {
  constructor(s = "[data-lazyload]", e = {}) {
    u(this, "observer");
    this.selector = s, this.options = e;
    const {
      root: r,
      rootMargin: i,
      threshold: o,
      useNativeLoading: n = !1
    } = this.options;
    n || (this.observer = new IntersectionObserver(v(this.options), {
      root: r,
      rootMargin: i,
      threshold: o
    }));
  }
  observe() {
    var o;
    const { root: s, onLoaded: e, useNativeLoading: r } = this.options, i = L(this.selector, s);
    for (const n of i)
      a(n) || (r || b ? (c(n, this.options), e == null || e(n)) : (o = this.observer) == null || o.observe(n));
  }
  /**
   * Load an element before it gets visible in the viewport
   */
  triggerLoad(s) {
    var e, r;
    a(s) || (c(s, this.options), (r = (e = this.options) == null ? void 0 : e.onLoaded) == null || r.call(e, s));
  }
}
let g;
(g = document.currentScript) && g.hasAttribute("init") && new w().observe();
export {
  w as default
};
